import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { IdentityV2 } from '@my-account/data-access/interfaces';
import { MyAccountErrorLogKeys } from '@shared/data-access/enums';
import { PurchasesService } from '@my-account/data-access/services';
import { ValidationService } from '@cart-checkout/checkout/data-access/services';
import { validateEuropeanDomain } from '@my-account/utils/validators';
import { MyAccountAnalyticsService } from '@shared/data-access/services';

@Component({
	selector: 'my-account-order-track-components-confirm-email-modal',
	templateUrl: './confirmation-email-modal.component.html',
	styleUrls: ['./confirmation-email-modal.component.scss'],
})
export class ConfirmationEmailModalComponent implements OnInit {
	@Input() identity: IdentityV2;
    @Input() addresses;
    @Input() orderNumber: string;
    @Output() closeEvent = new EventEmitter<void>();

    email: string;
    confirmationForm: UntypedFormGroup;
    resendError = false;
    resendSuccess = false;

    public get emailPattern(): string {
		return this.validationService.validate('email');
	}

    constructor(
        private analyticsService: MyAccountAnalyticsService,
        private purchasesService: PurchasesService,
        private validationService: ValidationService) {}

    ngOnInit() {
        this.reloadConfirmation();
    }

    public reloadConfirmation(){
        this.resendError = false;
        this.email = this.getEmail();

        this.confirmationForm = new UntypedFormGroup({
			confirmationEmail: new UntypedFormControl(
                this.email,
                {
                    validators: [
                        Validators.required,
                        Validators.email,
                        validateEuropeanDomain
                    ]
                }
            ),
		});
    }

    getEmail(): string {
        if (this.identity) {
            return this.identity.email.toLowerCase();
        }

        if (this.addresses?.email) {
            return this.addresses.email.toLowerCase();
        }

        if(this.addresses?.BILLING){
            return this.addresses?.BILLING?.email.toLowerCase();
        } else if (this.addresses?.SHIPPINGBILLING){
            return this.addresses?.SHIPPINGBILLING?.email.toLowerCase();
        }

        return null;
    }


    sendConfirmation() {
		this.analyticsService.triggerAnalyticsEvent('multiUseAnalyticsEvent', { "event" : 'MyAccountResendConfirmation'});
        this.resendError = false;
        if (this.confirmationForm.invalid) {
            this.resendError = true;
            return;
        }
        this.purchasesService.sendOrderConfirmationEmail(this.orderNumber, this.confirmationForm.controls['confirmationEmail'].value).subscribe({
            next: () => {
                this.resendSuccess = true;
                this.analyticsService.triggerAnalyticsEvent('OrderConfirmationEmailResendSuccess');
            },
            error: (err) => {
                this.resendError = true;
                this.analyticsService.generateLogError(MyAccountErrorLogKeys.MYACCOUNT_ORDER_DETAILS,'OrderConfirmationEmailResendError', err);
            }
        });
    }

    closeModal() {
        this.closeEvent.emit();
    }
}
